import { Box, FormControlLabel, Grid, Switch, Typography, useTheme } from "@mui/material";
import UXPageHeader from "../../../components/froms/UXPageHeader";
import useExcelImport from "./import.leads.hooks";
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import { useState } from "react";
import React from "react";

const ExcelDialogErrors = () => {
    const { errors, hasError, hasWarning } = useExcelImport();
    const [showErrors, setShowErrors] = useState(true);
    const [showWarnings, setShowWarnings] = useState(true);
    const theme = useTheme();
    
    return (
        <Box sx={{ mt: 2 }}>
            {(hasError || hasWarning) && <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="subtitle1" sx={{ mb: 2, mt: 2 }}>Errors & Warnings</Typography>
                <FormControlLabel control={<Switch checked={showErrors} onChange={() => setShowErrors(!showErrors)} />} label={<Typography variant='caption'>Errors</Typography>} />
                <FormControlLabel control={<Switch checked={showWarnings} onChange={() => setShowWarnings(!showWarnings)} />} label={<Typography variant='caption'>Warnings</Typography>} />
            </Box>}

            {(hasError || hasWarning) && <Grid container rowGap={2} spacing={3}>
                <Grid item xs={2}>Type</Grid>
                <Grid item xs={3}>Row/Col</Grid>
                <Grid item xs={7}>Message</Grid>
                {errors.filter(s => (showErrors && s.errorType === 'error')).map(err => <React.Fragment key={err.message}>
                    <Grid item xs={2} title={err.errorType}>
                        {err.errorType === 'warning' ? <WarningIcon sx={{ color: theme.palette.warning.main }} /> : <ErrorIcon sx={{ color: theme.palette.error.main }} />}
                    </Grid>
                    <Grid item xs={3}>
                        {err.rowNum} / {err.colNum}
                    </Grid>
                    <Grid item xs={7}>
                        {err.message}
                    </Grid>
                </React.Fragment>)}

                {errors.filter(s => (showWarnings && s.errorType === 'warning')).map(err => <>
                    <Grid item xs={2} title={err.errorType}>
                        {err.errorType === 'warning' ? <WarningIcon sx={{ color: theme.palette.warning.main }} /> : <ErrorIcon sx={{ color: theme.palette.error.main }} />}
                    </Grid>
                    <Grid item xs={3}>
                        {err.rowNum} / {err.colNum}
                    </Grid>
                    <Grid item xs={7}>
                        {err.message}
                    </Grid>
                </>)}
            </Grid>}
        </Box>
    )
}

export default ExcelDialogErrors;